<template>
  <a href="#" @click.prevent="$emit('more')">
    <b-spinner v-if="loading" small class="mr-2" />
    <small>show more +</small>
  </a>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
